/**
 * Component is used to show user's address informations
 *
 * @attr {String} [section-title = ''] - Title for address block
 * @attr {Boolean} [step-payment] - Different title style if you stay in payment step
 * @attr {String} [css-class = ''] - css class for component container
 *
 * @param {Object} [address] - User's address info from store
 *
 * HTML Structure
 *
 * <e2-user-address step-payment
 *      section-title="Your address"
 *      guest-store="cart"
 * ></e2-user-address>
 */

import { html } from 'lit-element';

import { LightLitElement } from '@elab/components';
import { selectors } from '@elab/core/store/user';
import { selectors as coreSelectors } from '@elab/core/store/selectors';
import connect from '@elab/core/store/connect';

export class UserAddress extends LightLitElement {
    static get properties() {
        return {
            sectionTitle: { type: String, attribute: 'section-title' },
            stepPayment: { type: Boolean, attribute: 'step-payment' },
            cssClass: { type: String, attribute: 'css-class' },
            storeNameForGuest: {
                type: String,
                attribute: 'store-name-for-guest',
            },
            address: { type: Object },
        };
    }

    constructor() {
        super();
        this.sectionTitle = '';
        this.cssClass = '';
        this.storeNameForGuest = 'cart';
    }

    render() {
        const {
            firstName = '',
            middleName = '',
            lastName = '',
            line1 = '',
            line2 = '',
            pobox = '',
            postalCode = '',
            town = '',
            country = {},
        } = this.address;

        return html`
            <div class="address__current-address ${this.cssClass || ''}">
                <h4 class="address__title${this.stepPayment ? '--payment' : ''}">
                    ${this.sectionTitle}
                </h4>

                <p class="address__row">
                    <span class="address__item">${firstName}</span>
                    <span class="address__item">${middleName}</span>
                    <span class="address__item">${lastName}</span>
                </p>
                <p class="address__row">${line1} ${line2} ${pobox}</p>
                <p class="address__row">${postalCode} ${town}</p>
                <p class="address__row">${country.name || ''}</p>
                <v-slot name="append"></v-slot>
            </div>
        `;
    }
}

const mapStateToProps = (state, ctx) => {
    const isAnonymous = selectors.isAnonymous(state);
    let address = selectors.getDefaultAddress(state);

    if (isAnonymous) {
        const store = coreSelectors.getStore(state, ctx.storeNameForGuest) || {};
        const userData = (store.data && store.data.user) || {};
        address = userData.guestAddress || {};
    }

    return { address };
};

export default () =>
    customElements.define('e2-user-address', connect(mapStateToProps)(UserAddress));
